// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1MWGG","label":"SetPasswdForm_label__CYNg1"};